import { ClientSerializer } from 'api/Serializers/Clients';
import { InstructorListSerializer } from 'api/Serializers/Instructors';

import ButtonLarge from 'components/button-large';
import Modal from 'components/modal';
import { UserType } from 'config';
import Pagination from 'containers/paginate';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getAccountDetail,
  getClientList,
  getInstructorsSchedulable,
} from 'state/selectors';
import { SHARED_ROUTES } from 'utils/routing';

const CreateConversationModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose(): void;
}) => {
  const user = useSelector(getAccountDetail);
  const clients = useSelector(getClientList);
  const instructors = useSelector(getInstructorsSchedulable);
  const [userSlice, setUserSlice] = useState<
    (ClientSerializer | InstructorListSerializer)[]
  >([]);
  const [search, setSearch] = useState('');
  const history = useHistory();
  const users = user.type === UserType.Instructor ? clients : instructors;
  const otherUserTypeStr =
    user.type === UserType.Instructor ? 'client' : 'instructor';

  useEffect(() => {
    let _users;
    if (search !== '') {
      _users = [...users]
        .map((user) => ({
          ...user,
          order: `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .indexOf(search.toLowerCase()),
        }))
        .filter((user) => user.order > -1)
        .sort((a, b) => a.order - b.order);
    } else {
      _users = [...users].sort((a, b) => {
        // push null recentAppointment values to bottom, then sort by recentAppointment descending
        if (!a.recentAppointment && b.recentAppointment) {
          return 1;
        } else if (!b.recentAppointment && a.recentAppointment) {
          return -1;
        }
        return a.recentAppointment === b.recentAppointment
          ? 0
          : a.recentAppointment > b.recentAppointment
          ? -1
          : 1;
      });
    }
    setUserSlice(_users);
  }, [search, clients, instructors]);

  const handleSelect = (user: ClientSerializer | InstructorListSerializer) => {
    history.push(SHARED_ROUTES.MESSAGES.nav(user.userId));
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      name="create-conversation-modal"
      title={`Select ${otherUserTypeStr}`}
      maxWidth="xs"
      fullWidth
    >
      <div className="mb-8">
        <p className="mb-6">
          Select a current or past {otherUserTypeStr} to message
        </p>
        <input
          className="px-4 py-3 mb-4 font-medium text-gray-600 bg-gray-200 border-transparent rounded-lg focus:bg-white focus:border-gray-400"
          placeholder="Search"
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          autoFocus={true}
        />
        <Pagination
          data={userSlice}
          render={({ key, ...user }) => (
            <ButtonLarge
              key={key}
              variant="blank"
              title={user.displayName}
              subtitle={
                user.numFutureAppointments === 0
                  ? 'No bookings'
                  : `${user.numFutureAppointments} more booked`
              }
              onClick={() => handleSelect(user)}
            />
          )}
          itemsPerPage={5}
          position="bottom"
        />
      </div>
    </Modal>
  );
};

export default CreateConversationModal;
